import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import routes from 'routes';
import './index.css';
import { useSelector } from 'react-redux';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const App = () => {
  const session = useSelector((state) => state?.session);
  const isLoggedIn = !!session?.user?.empDBID;

  const routing = createBrowserRouter(routes(isLoggedIn));

  return <RouterProvider router={routing} />;
};

export default App;
